export class AddressAddition {

	name:string;
	address:string;
	city:string;
	state:string;
	pincode:string;
	landmark ?:string;
	contactNumber:string;
	type: string;
	alternateContactNumber ?:string;
	gst ?: string;
	businessName?:string;
}
export class SelectedAddress{
	_selectedBillingAddress:AddressSuccess;
	_selectedShippingAddress:AddressSuccess;
	constructor(){}
	get selectedBillingAddress(){
		return this._selectedBillingAddress;
	}
	get selectedShippingAddress(){
		return this._selectedShippingAddress;
	}
	set selectedBillingAddress(selectedBillingAddress:AddressSuccess){
		this._selectedBillingAddress=selectedBillingAddress;
	}
	set selectedShippingAddress(selectedShippingAddress:AddressSuccess){
		this._selectedShippingAddress=selectedShippingAddress;
	}

}
export class AddressSuccess {

	name:string;
	address:string;
	addressId:string;
	city:string;
	state:string;
	pincode:string;
	landmark:string;
	contactNumber:string;
	type: string;
	alternateContactNumber:string;
	gst ?: string;
}